import {ADD_PERIOD_HANDLER_CURRENT_REQUEST} from "../../../enums/Request/currentRequestControls.types";

export const addPeriodHandlerCurrentRequest = () => {
    return {
        type: ADD_PERIOD_HANDLER_CURRENT_REQUEST,
    };
};
